<template>
  <div class="login-page">
    <div class="container-370">
      <div class="verticle-middle w-370">
        <div class="logo-choose-role text-center">
          <img class="w-180" src="../../assets/images/parts-logo.png" alt="">
        </div>
        <div class="button-group mt-47">
          <div class="buttons-flex mb-15">
            <router-link :to="{name: 'login', params: {userType: 'patient'}}" class="button info flex-1">患者の方</router-link>
          </div>
          <div class="buttons-flex mb-15">
            <router-link :to="{name: 'login', params: {userType: 'pharmacist'}}" class="button success flex-1">薬剤師の方</router-link>
          </div>
          <!-- <div class="buttons-flex mb-15">
            <router-link :to="{name: 'login', params: {userType: 'other'}}" class="button default flex-1">多職種の方</router-link>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {USER_TYPE_PATIENT, USER_TYPE_PHARMACIST, USER_TYPE_OTHER} from '@/const'

export default {
  mounted () {
    if (process.env.REMEMBER_USER_TYPE && localStorage.user_type) {
      let userType = null
      switch (parseInt(localStorage.getItem('user_type'))) {
        case USER_TYPE_PATIENT:
          userType = 'patient'
          break
        case USER_TYPE_PHARMACIST:
          userType = 'pharmacist'
          break
        case USER_TYPE_OTHER:
          // userType = 'other'
          break
      }
      if (userType) this.$router.push({name: 'login', params: {userType}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/FirstLogin.vue